import React from 'react';
import { ArrowRight } from 'lucide-react';
import './AnimatedCTA3D.css';

export const AnimatedCTA3D = ({ onClick, text = "Démarrer votre projet" }) => {
  return (
    <button
      onClick={onClick}
      className="animated-cta-3d group"
    >
      {/* 3D Rotating Icon Container */}
      <div className="icon-3d-container">
        {/* Background glow effect */}
        <div className="glow-ring"></div>
        
        {/* Main 3D Icon */}
        <div className="icon-3d">
          {/* Technical Grid Background */}
          <div className="tech-grid"></div>
          
          {/* Ruler (Règle graduée) */}
          <svg className="tool-ruler" viewBox="0 0 60 12" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="56" height="8" fill="#d4d4d4" stroke="#1a1a1a" strokeWidth="0.5" rx="1"/>
            <line x1="8" y1="6" x2="8" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
            <line x1="14" y1="6" x2="14" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
            <line x1="20" y1="6" x2="20" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
            <line x1="26" y1="6" x2="26" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
            <line x1="32" y1="6" x2="32" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
            <line x1="38" y1="6" x2="38" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
            <line x1="44" y1="6" x2="44" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
            <line x1="50" y1="6" x2="50" y2="9" stroke="#1a1a1a" strokeWidth="0.5"/>
          </svg>
          
          {/* Compass (Compas) */}
          <svg className="tool-compass" viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg">
            {/* Compass body */}
            <circle cx="20" cy="8" r="4" fill="#2C2C2C" stroke="#1a1a1a" strokeWidth="1"/>
            {/* Left leg */}
            <line x1="20" y1="8" x2="12" y2="42" stroke="#8b8b8b" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="42" r="2" fill="#1a1a1a"/>
            {/* Right leg with pencil */}
            <line x1="20" y1="8" x2="28" y2="42" stroke="#8b8b8b" strokeWidth="2" strokeLinecap="round"/>
            <line x1="28" y1="38" x2="28" y2="46" stroke="#4dffb8" strokeWidth="2.5" strokeLinecap="round"/>
            <circle cx="28" cy="46" r="1.5" fill="#4dffb8"/>
          </svg>
          
          {/* Pen/Plume */}
          <svg className="tool-pen" viewBox="0 0 8 50" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="penGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#c0c0c0"/>
                <stop offset="100%" stopColor="#606060"/>
              </linearGradient>
            </defs>
            <rect x="2" y="5" width="4" height="35" fill="url(#penGradient)" rx="0.5"/>
            <polygon points="4,40 2,48 6,48" fill="#1a1a1a"/>
            <circle cx="4" cy="3" r="2" fill="#a68966"/>
          </svg>
          
          {/* Technical Lines */}
          <div className="tech-lines">
            <div className="line line-1"></div>
            <div className="line line-2"></div>
            <div className="line line-3"></div>
          </div>
        </div>
      </div>
      
      {/* Button Text */}
      <span className="cta-text">{text}</span>
      
      {/* Arrow Icon */}
      <ArrowRight className="arrow-icon" />
      
      {/* Subtle particles effect */}
      <div className="particles">
        <span className="particle particle-1"></span>
        <span className="particle particle-2"></span>
        <span className="particle particle-3"></span>
      </div>
    </button>
  );
};
